import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogs } from "../context/LogContext";
import "./RegisterPhone.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const RegisterPhone = () => {
    const [phone, setPhone] = useState("");

    const navigate = useNavigate();
    const { addLog } = useLogs();

    useEffect(() => {
        const consent = sessionStorage.getItem("consentAccepted");
        if (!consent) {
            navigate("/consent", { state: { next: "/verify-phone" } });
        }
    }, [navigate]);

    const continueToRegister = () => {
        const phoneNumber = "+" + phone;
        const phoneRegex = /^\+91[6-9][0-9]{9}$/;

        addLog(`📱 Entered phone: ${phoneNumber}`);
        if (!phoneRegex.test(phoneNumber)) {
            addLog("❌ Invalid phone number");
            return;
        }

        addLog("➡️ Redirecting to register...");
        navigate("/register", { state: { phoneNumber } });
    };

    return (
        <div className="left-content">
            <h2>Enter Mobile Number</h2>

            <div className="phone-input">
                <PhoneInput
                    country="in"
                    value={phone}
                    onChange={setPhone}
                    international={false}
                    countryCodeEditable={false}
                    autoFormat={true}
                    placeholder="Enter your number"
                    enableSearch={false}
                />
            </div>

            <button onClick={continueToRegister}>Continue</button>
        </div>
    );
};

export default RegisterPhone;
